/**
 * Charma.sk — Chat Widget
 * Вставить в Shopify: theme.liquid перед </body>
 *
 * Замени WORKER_URL на свой Cloudflare Worker URL
 */

(function () {
  const WORKER_URL = "https://small-mountain-caac.korzhband.workers.dev";

  const ACCENT = "#1a5a4a";
  const ACCENT_LIGHT = "#e8f2ef";

  // ─── Стили ───────────────────────────────────────────────────────────────
  const style = document.createElement("style");
  style.textContent = `
    #charma-chat-btn {
      position: fixed;
      bottom: 90px;
      right: 24px;
      width: 56px;
      height: 56px;
      border-radius: 50%;
      background: ${ACCENT};
      color: #fff;
      border: none;
      cursor: pointer;
      box-shadow: 0 4px 16px rgba(0,0,0,0.18);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999;
      transition: transform 0.2s;
    }
    #charma-chat-btn:hover { transform: scale(1.08); }
    #charma-chat-btn svg { width: 26px; height: 26px; }
    @media (max-width: 768px) {
      #charma-chat-btn {
        bottom: 80px;
        right: 16px;
      }
      #charma-chat-window {
        bottom: 148px;
        right: 8px;
        left: 8px;
        width: auto;
      }
      #charma-chat-bubble {
        bottom: 148px;
        right: 16px;
      }
    }

    @keyframes charma-pop {
      from { opacity: 0; transform: translateY(8px); }
      to   { opacity: 1; transform: translateY(0); }
    }

    #charma-chat-window {
      position: fixed;
      bottom: 158px;
      right: 24px;
      width: 340px;
      max-width: calc(100vw - 32px);
      height: 480px;
      max-height: calc(100vh - 120px);
      background: #fff;
      border-radius: 16px;
      box-shadow: 0 8px 32px rgba(0,0,0,0.18);
      display: none;
      flex-direction: column;
      z-index: 9999;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
      overflow: hidden;
    }
    #charma-chat-window.open { display: flex; }

    #charma-chat-header {
      background: ${ACCENT};
      color: #fff;
      padding: 14px 16px;
      display: flex;
      align-items: center;
      gap: 10px;
      flex-shrink: 0;
    }
    #charma-chat-header .avatar {
      width: 36px; height: 36px; border-radius: 50%;
      background: rgba(255,255,255,0.2);
      display: flex; align-items: center; justify-content: center;
      font-size: 18px;
    }
    #charma-chat-header .info { flex: 1; }
    #charma-chat-header .name { font-weight: 700; font-size: 15px; }
    #charma-chat-header .status { font-size: 11px; opacity: 0.85; }
    #charma-chat-close {
      background: none; border: none; color: #fff;
      cursor: pointer; padding: 4px; opacity: 0.8;
      font-size: 20px; line-height: 1;
    }
    #charma-chat-close:hover { opacity: 1; }

    #charma-chat-messages {
      flex: 1;
      overflow-y: auto;
      padding: 16px;
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
    .charma-msg {
      max-width: 82%;
      padding: 9px 13px;
      border-radius: 16px;
      font-size: 14px;
      line-height: 1.45;
      word-wrap: break-word;
    }
    .charma-msg.bot {
      background: ${ACCENT_LIGHT};
      color: #1a1a1a;
      align-self: flex-start;
      border-bottom-left-radius: 4px;
    }
    .charma-msg.user {
      background: ${ACCENT};
      color: #fff;
      align-self: flex-end;
      border-bottom-right-radius: 4px;
    }
    .charma-msg.typing {
      background: ${ACCENT_LIGHT};
      align-self: flex-start;
      color: #888;
      font-style: italic;
      font-size: 13px;
    }

    #charma-chat-suggestions {
      padding: 0 16px 8px;
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
      flex-shrink: 0;
    }
    .charma-suggestion {
      background: none;
      border: 1.5px solid ${ACCENT};
      color: ${ACCENT};
      border-radius: 20px;
      padding: 5px 12px;
      font-size: 12px;
      cursor: pointer;
      transition: all 0.15s;
      white-space: nowrap;
    }
    .charma-suggestion:hover {
      background: ${ACCENT};
      color: #fff;
    }

    #charma-chat-input-row {
      display: flex;
      gap: 8px;
      padding: 12px 16px;
      border-top: 1px solid #eee;
      flex-shrink: 0;
    }
    #charma-chat-input {
      flex: 1;
      border: 1.5px solid #ddd;
      border-radius: 20px;
      padding: 8px 14px;
      font-size: 14px;
      outline: none;
      resize: none;
      font-family: inherit;
    }
    #charma-chat-input:focus { border-color: ${ACCENT}; }
    #charma-chat-send {
      width: 38px; height: 38px;
      border-radius: 50%;
      background: ${ACCENT};
      border: none;
      color: #fff;
      cursor: pointer;
      display: flex; align-items: center; justify-content: center;
      flex-shrink: 0;
    }
    #charma-chat-send:hover { opacity: 0.88; }
    #charma-chat-send svg { width: 18px; height: 18px; }
  `;
  document.head.appendChild(style);

  // ─── HTML ─────────────────────────────────────────────────────────────────
  const wrapper = document.createElement("div");
  wrapper.innerHTML = `
    <div id="charma-chat-window">
      <div id="charma-chat-header">
        <div class="avatar">💎</div>
        <div class="info">
          <div class="name">Charma asistentka</div>
          <div class="status">● Online — odpoviem hneď</div>
        </div>
        <button id="charma-chat-close" aria-label="Zavrieť">✕</button>
      </div>

      <div id="charma-chat-messages"></div>

      <div id="charma-chat-suggestions">
        <button class="charma-suggestion">Pomoc s výberom</button>
        <button class="charma-suggestion">Aké mám náramky?</button>
        <button class="charma-suggestion">Doručenie a platba</button>
        <button class="charma-suggestion">Darček pre niekoho</button>
      </div>

      <div id="charma-chat-input-row">
        <input id="charma-chat-input" type="text" placeholder="Napíšte správu..." autocomplete="off" />
        <button id="charma-chat-send" aria-label="Odoslať">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <line x1="22" y1="2" x2="11" y2="13"/>
            <polygon points="22 2 15 22 11 13 2 9 22 2"/>
          </svg>
        </button>
      </div>
    </div>

    <button id="charma-chat-btn" aria-label="Otvoriť chat">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
      </svg>
    </button>
  `;
  if ((document.documentElement.lang || '').toLowerCase().indexOf('pl') === 0) { const copies = {"Charma asistentka":"Asystentka Charma","● Online — odpoviem hneď":"● Online — odpowiem od razu","Zavrieť":"Zamknij","Pomoc s výberom":"Pomoc w wyborze","Aké mám náramky?":"Jakie są rodzaje bransoletek?","Doručenie a platba":"Dostawa i płatności","Darček pre niekoho":"Prezent dla bliskiej osoby","Napíšte správu...":"Napisz wiadomość...","Odoslať":"Wyślij","Otvoriť chat":"Otwórz czat"}; Object.keys(copies).forEach(s => { wrapper.innerHTML = wrapper.innerHTML.split(s).join(copies[s]); }); }
  document.body.appendChild(wrapper);

  // ─── Логика ───────────────────────────────────────────────────────────────
  const win = document.getElementById("charma-chat-window");
  const btn = document.getElementById("charma-chat-btn");
  const closeBtn = document.getElementById("charma-chat-close");
  const messagesEl = document.getElementById("charma-chat-messages");
  const input = document.getElementById("charma-chat-input");
  const sendBtn = document.getElementById("charma-chat-send");
  const suggestions = document.querySelectorAll(".charma-suggestion");

  let history = [];
  let isTyping = false;


  function openChat() {
    win.classList.add("open");
    btn.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
      <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
    </svg>`;
    if (history.length === 0) addMessage("bot", ((document.documentElement.lang || '').toLowerCase().indexOf('pl') === 0 ? "Cześć! Jestem Charma 💎 Pomogę Ci wybrać biżuterię lub odpowiem na pytania dotyczące zamówienia. W czym mogę pomóc?" : "Ahoj! Som Charma 💎 Pomôžem vám vybrať správny šperk alebo odpovedám na otázky o objednávke. Čím môžem pomôcť?"));
    setTimeout(() => input.focus(), 100);
  }

  function closeChat() {
    win.classList.remove("open");
    btn.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
    </svg>`;
  }

  btn.addEventListener("click", () => {
    win.classList.contains("open") ? closeChat() : openChat();
  });
  closeBtn.addEventListener("click", closeChat);

  function formatText(text) {
    // Escape HTML
    let s = text.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;");
    // **bold** → <b>
    s = s.replace(/\*\*(.+?)\*\*/g, "<b>$1</b>");
    // URLs → clickable links
    s = s.replace(/(https?:\/\/[^\s<]+)/g, '<a href="$1" target="_blank" rel="noopener" style="color:inherit;text-decoration:underline;">$1</a>');
    // newlines → <br>
    s = s.replace(/\n/g, "<br>");
    return s;
  }

  function addMessage(role, text) {
    const div = document.createElement("div");
    div.className = `charma-msg ${role}`;
    div.innerHTML = formatText(text);
    messagesEl.appendChild(div);
    messagesEl.scrollTop = messagesEl.scrollHeight;
    return div;
  }

  function showTyping() {
    const div = document.createElement("div");
    div.className = "charma-msg typing";
    div.id = "charma-typing";
    div.textContent = ((document.documentElement.lang || '').toLowerCase().indexOf('pl') === 0 ? "Charma pisze…" : "Charma píše…");
    messagesEl.appendChild(div);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function hideTyping() {
    const t = document.getElementById("charma-typing");
    if (t) t.remove();
  }

  async function sendMessage(text) {
    if (!text.trim() || isTyping) return;
    isTyping = true;

    // Скрыть подсказки
    document.getElementById("charma-chat-suggestions").style.display = "none";

    addMessage("user", text);
    history.push({ role: "user", content: text });

    input.value = "";
    showTyping();

    try {
      const res = await fetch(WORKER_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ messages: history }),
      });

      const data = await res.json();
      hideTyping();
      const reply = data.reply || ((document.documentElement.lang || '').toLowerCase().indexOf('pl') === 0 ? "Wystąpił błąd. Spróbuj ponownie." : "Prepáčte, nastala chyba. Skúste znova.");
      addMessage("bot", reply);
      history.push({ role: "assistant", content: reply });
    } catch {
      hideTyping();
      addMessage("bot", ((document.documentElement.lang || '').toLowerCase().indexOf('pl') === 0 ? "Obecnie jestem niedostępna. Napisz do nas: info@charma.sk" : "Prepáčte, momentálne nie som dostupná. Napíšte nám na info@charma.sk"));
    }

    isTyping = false;
  }

  sendBtn.addEventListener("click", () => sendMessage(input.value));
  input.addEventListener("keydown", (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      sendMessage(input.value);
    }
  });

  suggestions.forEach((btn) => {
    btn.addEventListener("click", () => sendMessage(btn.textContent));
  });
})();
